// This file is auto-generated don't edit it!
import { Component } from '@angular/core';

@Component({
    selector: 'ui-accordion-docs',
    templateUrl: './accordion.docs.generated.html',
})
export class UIAccordionDocs { }
